module.exports = __webpack_public_path__ + "static/media/40.4cec97d1.jpg";